import {RouteDefinition} from "../../../../routes"
import {ControlSortingScreen} from "./Control"
import {HomepageEditScreen } from "./HomePage/HomepageEditScreen"
import {HomepageListScreen} from "./HomePage/HomepageListScreen"
import {SensorSortingScreen} from "./Sensor"
import {LeftMenuListScreen} from "./LeftMenu/LeftMenuListScreen";
export const SortingMenuSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/custom-menu/sorting-menu/homepage",
        component: HomepageListScreen
    },
    {
        routerLink: "/settings/custom-menu/sorting-menu/homepage/edit/:id",
        component: HomepageEditScreen
    },
    {
        routerLink: "/settings/custom-menu/sorting-menu/homepage/edit",
        component: HomepageEditScreen
    },
    {
        routerLink: "/settings/custom-menu/sorting-menu/controls",
        component: ControlSortingScreen
    },
    {
        routerLink: "/settings/custom-menu/sorting-menu/sensors",
        component: SensorSortingScreen
    },
    {
        routerLink: "/settings/custom-menu/sorting-menu/left-menu/",
        component: LeftMenuListScreen
    }
]
